import React,{ useEffect } from 'react';
import { batch, useSelector, useDispatch } from 'react-redux';
import { Link, useLocation } from "react-router-dom";
import { useImmer } from 'use-immer';
import axios from 'axios';

const SallStudies = ({ init }) => {
  const setApp = useDispatch();
  const location = useLocation();
  const { filtered } = useSelector(s => s.allStudies);
  const [list, setList] = useImmer([]);
  const [studyList, setStudyList] = useImmer([]);
  const [filterSearch, setFilterSearch] = useImmer('');

  useEffect(() => {
    axios.get(`/allstudies?t=${new Date().getTime()}`)
    .then((r) => {
      setApp({ type: '_ALL_STUDIES', payload: ['allStudies', r.data] });
      setStudyList(r.data);
      setList(r.data);
    });

    axios.get('/tabs/?data=Species&t='+new Date().getTime())
    .then((r) => {
      setApp({ type: '_SPECIES', payload: ['speciesStudyList', r.data] });
    });

    axios.get('/tabs/?data=Countries&t='+new Date().getTime())
    .then((r) => {
      setApp({ type:'_COUNTRY', payload: ['countryStudyList', r.data] });
    });

    axios.get('/tabs/?data=References&t='+new Date().getTime())
    .then((r) => {
      setApp({ type:'_REFERENCE', payload: ['referenceStudyList', r.data] });
    });
  }, []);

  if (location.pathname !== '/') {
    return <div className="lds-dual-ring2" />;
  }

  return (
    <>
      {
        init ? null : (
          <>
            <h6 className="sb-filter-text">
              <i className="fa fa-list" />
              {filtered.length ? ' FILTERED ' : ' '}
              STUDIES
            </h6>

            <div id="sb-filter-list">
              {
                !list.length
                  ? null
                  : (
                      <span id="sb-total-projects">
                        {'Total: '}
                        <b>{list.length}</b>
                        {` Stud${list.length > 1 ? 'ies' : 'y'}`}
                      </span>
                    )
              }
            </div>

            <div className="sb-project-list">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text" id="basic-addon1">
                    <i className="fa fa-search"></i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  value={filterSearch}
                  placeholder="Type to filter study list below..."
                  aria-label="Type to filter study list below..."
                  aria-describedby="basic-addon1"
                  onChange={(e) => {
                    setFilterSearch(e.target.value)
                    const regex = new RegExp(
                      `^.*${
                        e.target.value
                          .trim()
                          .replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')
                      }.*$`, `i`
                    );
                    const s = e.target.value.trim()
                      ? list.filter(v => regex.test(v.title))
                      : list;
                    setStudyList(s);
                  }}
                />
              </div>
              {
                studyList.length ?
                (
                  <>
                    <ul className="list-unstyled">
                    {
                      studyList.map((d)=>{

                        return (
                          <li role="presentation" key={d.studyId}
                            onClick={()=>{
                              batch(()=>{
                                setApp({
                                  type: '_STUDY_DETAIL',
                                  payload: ['studyID', [d.studyId]]
                                });
                                setApp({
                                  type:'_STUDY_DETAIL',
                                  payload:['studyTitle', d.title]
                                });
                              });
                          }}>
                            <Link to={`/study/${d.studyId}`}>
                              {d.title}
                            </Link>
                          </li>
                        )
                      })
                    }
                    </ul>
                  </>
                ) : null
              }
            </div>
          </>
        )
      }
    </>
  );
};

export default SallStudies;
